import React from 'react';
import './Reviews.css';

const Reviews = () => {
  const reviews = [
    {
      id: 1,
      quote: "I appreciate the consistent reminders to check my horoscope. The remedies are simple and effective.",
      author: "Anjali S."
    },
    {
      id: 2,
      quote: "AstroIndia helped me begin the process of understanding my career path. The astrologer was very knowledgeable.",
      author: "Rajesh K."
    },
    {
      id: 3,
      quote: "Strategies in the courses allowed me to learn Vedic astrology from scratch. Best platform in India.",
      author: "Meera P."
    }
  ];

  return (
    <section className="reviews-section">
      <div className="reviews-container">
        <h2 className="section-title">Reviews from our Community</h2>
        <div className="reviews-grid">
          {reviews.map((review) => (
            <div key={review.id} className="review-card">
              <div className="review-stars">
                {Array.from({ length: 5 }).map((_, i) => (
                  <span key={i} className="star">★</span>
                ))}
              </div>
              <p className="review-quote">"{review.quote}"</p>
              <p className="review-author">- {review.author}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;

